import { Component, Input } from '@angular/core';
import { SearchResultListItem } from '../../models/search-result-list-item';
import { AlgoliaEntity } from '../../enums/algolia-entity';
import { InstantSearchService } from '../../services/instant-search.service';
import { AlgoliaRecordHit } from '../../models/algolia-record-hit';
import { AlgoliaRecordHitService } from '../../services/algolia-record-hit.service';
import { materialSymbols } from '../../../../../shared/constants/material-symbols';
import { BallotType } from '../../../../../shared/enums/ballot-type-enum';
import { StatusBadgeColourScheme } from '../../../../controls/status-badge/status-badge-constants';



@Component({
  selector: 'app-search-result-item',
  standalone: false,
  templateUrl: './search-result-item.component.html',
  styleUrl: './search-result-item.component.scss'
})
export class SearchResultItemComponent {
  @Input() algoliaRecordHit : AlgoliaRecordHit | null = null;

  statusBadgeColourSchemeEnum = StatusBadgeColourScheme;

  baseId: string = '';
  entityId: string = '';
  searchResultItem: SearchResultListItem | null = null;


  ballotEntityType = BallotType;
  algoliaEntityType = AlgoliaEntity;
  iconName: string = '';


  constructor(
    public _instantSearchService: InstantSearchService,
    private _algoliaRecordHitService: AlgoliaRecordHitService,
  ) { }

  ngOnInit(): void {

    if (this.algoliaRecordHit) {
      this.searchResultItem = this._algoliaRecordHitService.getListItem(this.algoliaRecordHit);
      this.baseId = 'search-result-item-' + this.algoliaRecordHit.__position;
      this.setIconName();
      this.setEntityId();
    }
  }

  setEntityId() {
    if (this.algoliaRecordHit) {
      switch(this.algoliaRecordHit.entityType) {
        case AlgoliaEntity.Ballot:
          this.entityId = this.algoliaRecordHit.ballotId ? this.algoliaRecordHit.ballotId.toString() : '';
          break;
        case AlgoliaEntity.Project:
          this.entityId = this.algoliaRecordHit.projectId ? this.algoliaRecordHit.projectId.toString() : '';
          break;
        case AlgoliaEntity.Committee:
          this.entityId = this.algoliaRecordHit.committeeCodeForDisplay ? this.algoliaRecordHit.committeeCodeForDisplay : '';
          break;
        case AlgoliaEntity.Publication:
          this.entityId = this.algoliaRecordHit.publicationUri ? this.algoliaRecordHit.publicationUri : '';
          break;
        default:
          this.entityId = '';
      }
    }
  }

  setIconName(): void {
    if (this.searchResultItem) {
      switch (this.searchResultItem.entityType) {
        case AlgoliaEntity.Ballot:
          this.iconName = materialSymbols.howToVote;
          break;
        case AlgoliaEntity.Committee:
          this.iconName = materialSymbols.groups;
          break;
        case AlgoliaEntity.Project:
          this.iconName = materialSymbols.folderOpen;
          break;
        case AlgoliaEntity.Publication:
          this.iconName = materialSymbols.description;
          break;
        default:
          this.iconName = materialSymbols.search;
      }
    }
  }
}
